import Chevron from '../../../assets/chevron.svg';

const ChevronIcon = (props: React.SVGProps<SVGSVGElement> & { rotation?: number; color?: string }): JSX.Element => {
  const { rotation = 0, color = 'currentColor', ...restProps } = props;

  return <Chevron style={{ color }} transform={`rotate(${rotation})`} {...restProps} />;
};

export default ChevronIcon;
